import { record } from '@root/src/web/browser/ophan/ophan';
const recordBannerTimeoutInOphan = (bannerId) => record({
    component: 'banner-picker-timeout-dcr',
    value: bannerId,
});
const timeoutify = (banner) => {
    let timer;
    const canShow = () => new Promise((resolve) => {
        if (banner.timeoutMillis) {
            timer = window.setTimeout(() => {
                recordBannerTimeoutInOphan(banner.id);
                resolve({ result: false });
            }, banner.timeoutMillis);
        }
        banner.canShow().then((result) => resolve(result));
    });
    const cancelTimeout = () => timer && clearTimeout(timer);
    return {
        ...banner,
        canShow,
        cancelTimeout,
    };
};
const clearAllTimeouts = (banners) => banners.map((b) => b.cancelTimeout());
const defaultShow = () => null;
export const pickBanner = (banners) => new Promise((resolve) => {
    const bannersWithTimeout = banners.map(timeoutify);
    const results = bannersWithTimeout.map((banner) => banner.canShow());
    const winner = results.reduce(async (winningBannerSoFar, canShow, idx) => {
        const runningIdx = (await winningBannerSoFar).idx;
        if (runningIdx >= 0) {
            return winningBannerSoFar;
        }
        const result = await canShow;
        bannersWithTimeout[idx].cancelTimeout();
        if (result.result) {
            return { idx, meta: result.meta };
        }
        return winningBannerSoFar;
    }, Promise.resolve({ idx: -1 }));
    winner.then(({ idx, meta }) => {
        clearAllTimeouts(bannersWithTimeout);
        resolve(idx === -1
            ? defaultShow
            : () => bannersWithTimeout[idx].show(meta));
    });
});
